import script from "./device-common-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-common-info.vue?vue&type=script&lang=ts&setup=true"

import "./device-common-info.vue?vue&type=style&index=0&id=9597f822&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9597f822"]])

export default __exports__